import { IGenericBriefStepOption } from '@pageFeatures/design/briefingForm/types'
import React, { useEffect, useState } from 'react'
import {
  usePreloadedAnswers,
  useReadOnlyMode,
} from '../../BriefingFormDataProvider'
import { BriefSliderCard } from './BriefSliderCard'
import { KeenSliderWrapper } from '../../../../../../components/common/KeenSliderWrapper'
import { useDevice } from '@utils/responsiveness/useDevice'
import { optionKeyToKebabCase } from '@pageFeatures/design/briefingForm/utils'

interface IBriefCardsSelection {
  options: IGenericBriefStepOption[]
  valueKey: string
  onChange: (value) => void
}

export function BriefCardsSelection({
  options,
  valueKey,
  onChange,
}: IBriefCardsSelection) {
  const [selectedOption, setSelectedOption] = useState<IGenericBriefStepOption>(
    options?.[0] || null
  )
  const preloadedAnswers = usePreloadedAnswers()
  const readOnlyMode = useReadOnlyMode()
  const { isMobile } = useDevice()

  const selectOption = (option) => {
    if (!readOnlyMode) {
      setSelectedOption(option)
    }
  }

  useEffect(() => {
    if (selectedOption?.value) {
      const optionToSubmit = {}
      optionToSubmit[optionKeyToKebabCase(valueKey || selectedOption.value)] =
        selectedOption.value
      onChange(optionToSubmit)
    }
  }, [selectedOption])

  useEffect(() => {
    if (preloadedAnswers && preloadedAnswers[valueKey]) {
      const preselectedOption = options.find(
        (option) => option.value === preloadedAnswers[valueKey]
      )
      if (preselectedOption) {
        setSelectedOption(preselectedOption)
      }
    } else {
      setSelectedOption(options?.[0])
    }
  }, [preloadedAnswers])

  return (
    options?.length && (
      <div className="relative w-full max-w-full lg:max-w-[530px] font-mori">
        <KeenSliderWrapper
          initialConfig={{ perView: 2.15, spacing: 8 }}
          className="w-full"
          isShowArrows={!isMobile}
          trackingIdentifier="briefing-form-card"
        >
          {options?.map((option, index) => {
            return (
              <BriefSliderCard
                {...option}
                key={option.label + index}
                className={`keen-slider__slide ${
                  readOnlyMode ? 'pointer-events-none' : 'pointer-events-auto'
                }`}
                selected={selectedOption?.value === option.value}
                onSelection={() => selectOption(option)}
              />
            )
          })}
        </KeenSliderWrapper>
      </div>
    )
  )
}
